import RetrievePage from './RetrievePage';
import { keycloak } from '../../keycloak';
import { Navigate, Route, Routes } from 'react-router-dom';
import { withRouter } from '../withRouter';

export const RetrieveListRoutes = () => {
  const isItAdmin = keycloak.hasRealmRole('Role_IT_Administrator');

  return (
    <div className="app-wrapper h-100" style={{ padding: '100px' }}>
      <Routes>
        <Route path="/" element={isItAdmin ? <RetrievePage /> : <Navigate to={'/tff/common/error-403'} />} />
      </Routes>
    </div>
  );
};

export default withRouter(RetrieveListRoutes);
